<template lang="pug">
.container
  el-card.card
    el-form(label-width="120px;" @submit.native.prevent)
      el-form-item(label="用户名")
        el-input(v-model="username")
      el-form-item(label="密码")
        el-input(type="password" v-model="password")
      el-row.footer
        el-button(type="primary" native-type="submit" @click="Login") 登录
</template>

<script>
export default {
    data() {
        return {
            username: '',
            password: ''
        }
    },
    methods: {
        async Login() {
            let params = {
                username: this.username,
                password: this.password
            }
            let res = await this.$api.Login(params)
            if (res) {
                this.$store.commit('setToken', res.token)
                this.$api._RefreshInstance()
                let info = await this.$api.GetInfo()
                console.log(info)
                this.$store.commit('setUserInfo', info)
                this.$router.push({name: 'index'})
            }
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    background:url('/bg.jpeg');
    justify-content: center;
    align-items: center;

    .card {
        width: 300px;
        max-height: 320px;
        text-align: center;
    }

    .footer {
        .el-button {
            width: 100%;
        }
    }
}
</style>